import { ParticipationSetsGridColDef } from '../../types';

type Value = string | null | undefined;

export const uploadedByColDef: ParticipationSetsGridColDef<Value> = {
  // TODO - when field is available on graph change to lastUploadedBy.email
  field: 'uploadedBy',
  headerName: 'Uploaded By',
  filter: 'agTextColumnFilter',
  width: 208,
  floatingFilter: true,
  // TODO - not yet supported on the graph
  sortable: false,
};
